
import { Backdrop, Box, CircularProgress, Modal } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { downloadFile } from "../buyerPurchaseOrder";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import checkImage from "../../assests/images/check-circle.png";
import AlertComponent from "../alert/alert";
import { isEmptyDash } from "../../constant";

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const P2PDownload = (props) => {

  const [downloadEl, setdownloadEl] = React.useState(null);
  const [confirmObj, setConfirmObj] = useState({});
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] = useState(false);
  const [selectedPOArr, setSelectedPOArr] = useState([]);

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {

  }, []);

  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const openConfirmModal = (param) => {
    // if (props?.selectedArr?.length < 1) {
    //   setAlertComponent({ open: true, type: "error", message: `Please select an id. ` });
    //   return;
    // }
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    }
    if (param == "mdcc") {
      obj["text"] = "MDCC";
    }
    if (param == "documents") {
      obj["text"] = "Documents";
    }
    if (param == "pdf") {
      obj["text"] = "PDF";
    }
    setConfirmObj(obj);
    setOpenPoPdfPurchaseModal(true);
  }

  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenPoPdfPurchaseModal(false);
  }

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      "type": confirmObj?.id, // "line-item", header, 
      // ...props?.filterFormData
    };
    
    if (!isEmptyDash(props?.filterText)) {
      bodyData["search"] = props?.filterText;
    }
    if (!isEmptyDash(props?.filterFormData)) {
      bodyData = {...bodyData, ...props?.filterFormData};
    }
    
    let fileName = "";
    // if (props.type == "GRN") {
    //   bodyData["grnIds"] = props?.selectedArr;
    //   fileName = `${props?.selectedPOJsonArr[0]?.grnNumber}`;
    // }
    // if (props.type == "LR") {
    //   bodyData["lorryReceiptIds"] = props?.selectedArr;
    //   fileName = `${props?.selectedPOJsonArr[0]?.lrNumber}`;
    // }
    // if (props.type == "Purchase_Invoice") {
    //   bodyData["invoiceIds"] = props?.selectedArr;
    //   fileName = `${props?.selectedPOJsonArr[0]?.invoiceNumber}`;
    // }

    
    // if (props?.selectedArr.length > 1) {
    //   if (confirmObj?.id == "header") {
    //     fileName = `${props.type}_HeaderLevelExcel.zip`;
    //   }
    //   if (confirmObj?.id == "line-item") {
    //     fileName = `${props.type}_LineItemLevelExcel.zip`;
    //   }
    //   if (confirmObj?.id == "mdcc") {
    //     fileName = `${props.type}_MDCC_PDF.zip`;
    //   }
    //   if (confirmObj?.id == "documents") {
    //     fileName = `${props.type}_DOCUMENTS.zip`;
    //   }
    //   if (confirmObj?.id == "pdf") {
    //     fileName = `${props.type}_Pdf.zip`;
    //   }
    // } else {
        
    //   if (confirmObj?.id == "header") {
    //     fileName += "_HerderLevelExcel.xlsx";
    //   }
    //   if (confirmObj?.id == "line-item") {
    //     fileName += "_LineItemExcel.xlsx";
    //   }
    //   if (confirmObj?.id == "mdcc") {
    //     fileName += "_MDCC.pdf";
    //   }
    //   if (confirmObj?.id == "documents") {
    //     fileName += "_DOCUMENTS.pdf";
    //   }
    //   if (confirmObj?.id == "pdf") {
    //     fileName += "_PDF.pdf";
    //   }
    // }
    

    const data = {
      url: props?.url,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {        
        if (isEmptyDash(response)) {
          setOpenPoPdfPurchaseSuccessModal(true);       
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenPoPdfPurchaseModal(false);
      })
  }


  return (
    <>
      {/* P2P Module Download btn */}
      <div>
        <Button
          className="vendor_btn vendor_maine_contents"
          id="basic-button"
          aria-controls={download ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={download ? "true" : undefined}
          onClick={handleClicks}
        >
          <FileDownloadIcon />
          Download
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={downloadEl}
          open={download}
          onClose={handleCloses}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => openConfirmModal("header")}>
            Header Level Excel
          </MenuItem>
          <MenuItem onClick={() => openConfirmModal("line-item")}>
            Line Item Level Excel
          </MenuItem>
          <MenuItem  onClick={() => openConfirmModal("pdf")}>
                      PDF
                    </MenuItem>
          {/* <MenuItem onClick={() => openConfirmModal("documents")}>
            Documents
          </MenuItem> */}
        </Menu>
      </div>

      {/* Header Level Excel Purchase listing */}

      <Modal
        open={openpopdfpurchasemodal}
        onClose={closeConfirmModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="modal_react_controlpanel_employees">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenPoPdfPurchaseModal(false)}
            ></button>
          </div>
          <div class="modal-bodys">
            <p class="project_Manager_bidding">
              Are you sure you want to download
              <br /> {confirmObj?.text}
            </p>
            <div className="all_btn_modal_listing">
              <button
                href="onboarding_status.html"
                className="view_progresse"
                onClick={downloadPO}
              >
                Yes
              </button>

              <button
                href="onboarding_status.html"
                className="view_lsting"
                onClick={closeConfirmModal}
              >
                No
              </button>
            </div>
          </div>
        </Box>
      </Modal>
      {/* Header Level Sucessfully Purchase listing */}
      <Modal
        open={openpopdfpurchasesuccessmodal}
        onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="modal_react_controlpanel_employees">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
            ></button>
          </div>
          <div class="modal-bodys">
            <img src={checkImage} alt="" />
            <p class="project_manager_bidding">
              Selected <b>{confirmObj?.text}</b> has been
              <br /> successful download
            </p>
            <div className="all_btn_modal_listing">
              <button
                href="onboarding_status.html"
                className="view_progresse"
                onClick={() => {
                  setOpenPoPdfPurchaseSuccessModal(false);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default P2PDownload;